export default __webpack_public_path__ + "static/media/mig_email.82caa4c3.svg";